//====================================================
//  Initialization Wow
//====================================================
function fn_components_wow(){
	if ($('[data-sal]').length){
		sal({
			threshold: 0.5
		});
	}
}
